import { mapState } from 'vuex';
import moment from 'moment'
import 'moment/locale/ru';

import f from "@/application/shared/functions.js";

export default {
    name: 'date',
    props: {
        date : [String, Date],
        relative : {
            type : Boolean,
            default : true
        },

        nofuture : Boolean
    },

    computed: mapState({
        auth : state => state.auth,

        label : function(){

            var date = this.date

            if(typeof date == 'string') date = f.date.fromstring(date, true)

            moment.locale(this.$i18n.locale)

            

            var e = moment(moment.utc(date)).local()

            if(this.relative) {

                const diffSeconds = Math.abs(moment().diff(e, 'seconds'))

                if (diffSeconds < 5){
                    return this.$t('app.now')
                }

                var label = e.fromNow();

                return label
            }

            return e.format('MM/DD/YYYY');

        }
    }),
}